import { render, staticRenderFns } from "./SupportTicketInboxModal.vue?vue&type=template&id=224e0207&scoped=true&"
import script from "./SupportTicketInboxModal.vue?vue&type=script&lang=js&"
export * from "./SupportTicketInboxModal.vue?vue&type=script&lang=js&"
import style0 from "./SupportTicketInboxModal.vue?vue&type=style&index=0&id=224e0207&prod&lang=scss&"
import style1 from "./SupportTicketInboxModal.vue?vue&type=style&index=1&id=224e0207&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224e0207",
  null
  
)

export default component.exports